import script from "./FIApps.vue?vue&type=script&setup=true&lang=js"
export * from "./FIApps.vue?vue&type=script&setup=true&lang=js"

import "./FIApps.vue?vue&type=style&index=0&id=3ab610aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ab610aa"]])

export default __exports__